import { Link } from "react-router-dom";

const forumCategories = [
  { id: 1, title: "Show & Tell", description: "Share your latest junk journal spreads, snail mail creations, and finished projects with the community.", icon: "ri-image-line", color: "bg-amber-50", accent: "text-amber-700" },
  { id: 2, title: "Pen Pal Matching", description: "Find your perfect pen pal! Post your interests, swap addresses, and start beautiful snail mail friendships.", icon: "ri-mail-send-line", color: "bg-rose-50", accent: "text-rose-700" },
  { id: 3, title: "Techniques & Tutorials", description: "Learn new skills, share tutorials, and ask questions about junk journaling and paper crafting techniques.", icon: "ri-lightbulb-line", color: "bg-green-50", accent: "text-green-700" },
];

export default function ForumsPreviewSection() {
  return (
    <section className="py-20 bg-[#faf8f4]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#f5ede0] text-[#8b5e3c] text-xs font-semibold uppercase tracking-widest mb-4">
            <i className="ri-discuss-line"></i>
            Community
          </div>
          <h2 className="text-4xl font-bold text-[#2c1e0f]" style={{ fontFamily: "'Playfair Display', serif" }}>
            Connect With Fellow Creators
          </h2>
          <p className="text-[#7a6555] mt-2 max-w-xl mx-auto">
            Share your projects, find pen pals, swap ephemera, and learn new techniques with fellow enthusiasts.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-10">
          {forumCategories.map((forum) => (
            <Link
              key={forum.id}
              to="/forums"
              className="group p-6 rounded-2xl bg-white border border-[#ede5d8] hover:border-[#c9a87c]/50 hover:bg-[#fdf9f4] transition-all duration-300 cursor-pointer"
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-xl ${forum.color} mb-4`}>
                <i className={`${forum.icon} text-lg ${forum.accent}`}></i>
              </div>
              <h3 className="font-bold text-[#2c1e0f] text-lg mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                {forum.title}
              </h3>
              <p className="text-sm text-[#7a6555] leading-relaxed mb-4">{forum.description}</p>
              <span className="text-xs font-semibold text-[#8b5e3c] group-hover:underline">
                Join the discussion →
              </span>
            </Link>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/forums"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-[#c9a87c] text-[#8b5e3c] font-semibold text-sm hover:bg-[#f5ede0] transition-colors whitespace-nowrap"
          >
            View All Forums
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
